module.exports = __webpack_public_path__ + "img/uruguay.4a399aa.webp";